module.exports = __webpack_public_path__ + "img/pre_calificador.6c358273.png";